import styled, { css, keyframes } from 'styled-components';

const translate = keyframes`
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  60% {
    transform: translateY(-5%);
    opacity: 1;
  }
  100% {
    transform: translateY(0);

  }
`;

const translateReverse = keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  40% {
    transform: translateY(-5%);
  }
  100% {
    transform: translateY(100%);
    opacity: 0;
  }
`;

const backgroundAnimation = keyframes`
  0% {
  }
  100% {
    backdrop-filter: blur(4px) brightness(0.85);
  }
`;

export const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  padding: 20px 20px;
  z-index: 1;
  background-Color: rgba(52, 52, 52, 0.2);
  animation: ${backgroundAnimation} 0.2s linear forwards;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: absolute;
  background: #FFF; 
  width: 600px;
  max-width: 90%;
  height: 400px;
  max-height: 68%;
  position: absolute;
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  -moz-box-shadow: rgba(0,0,0,0.3) 0 1px 3px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  
  ${state => state.closed === true ? css`
    animation: ${translateReverse} 0.4s ease-in forwards;
  `: css`
    animation: ${translate} 0.4s ease-out forwards;
  `};

  .add-child {
    height: 64%;
  }
  form {
    width: 90%;
    @media (max-width: 600px) {
      display: flex;
      padding-right: 1.5rem;
      flex-direction: column;
      overflow: auto;
    }
  }

  .parent-info {
    display: grid;
    grid-column-gap: 2rem;
    grid-template-columns: 1fr 1fr;

    @media (max-width: 600px) {
      display: flex;
      flex-direction: column;
      padding-top: 0.5rem;
      .input-div {
        padding-bottom: .25rem;
      }
    }
  }

  #exit-button {
    background: none;
    border: none;
    position: absolute;
    top: 15px;
    right: 20px;
  }
  
  h1 {
    color: var(--gray-800);
    font-size: 1.8rem;
    position: absolute;
    top: 1.5rem;
    margin: 0 auto;
    margin-bottom: .8rem;

    @media (max-width: 600px) {
      top: 3;
      font-size: 1.6rem;
    }
  }

  hr {
    border: 1px solid var(--gray-800);
  }

  .submit-button {
    padding: 6px;
    width: 150px;
    border-radius: 8px;
    border: 2px solid var(--light-green);
    color: #FFF;
    background: var(--light-green);
    font-weight: bold;
    @media (max-width: 600px) {
      bottom: 1.5rem;
    }
    transition: 0.2s;
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 4px 8px rgba(0,0,0,.6);
    }
  }


`;
